export default __webpack_public_path__ + "static/media/caution.2bae031f.svg";